<!-- <p>event-details works!</p> -->
<div class="main-events-div">
    @if (!wrongAccount) {
    <div class="title-div">
        <span style="font-size: large; font-weight: bolder;">
            @if (ruleEvent) {
            Rule Event Triggered by {{ruleEvent.AssetName}}
            }
            @else if (offlineEvent) {
            Offline Event Triggered by {{ offlineEvent.SensorName }}
            }
            @else if (webhookEvent) {
            Webhook Event Triggered by {{ webhookEvent.ClientWebhookID }}
            }
            @else if (deviationEvent) {
            Deviation Event Triggered by {{ deviationEvent.AssetName }} - {{deviationEvent.AssetDescription}}
            }
        </span>
        <span class="toolbar-spacer"></span>
        <button mat-raised-button (click)="back()" style="margin-bottom: 0.5em;" class="app-icon--back">
            <mat-icon />
            <span>Back</span>
        </button>
    </div>
    <div class="button-div">
        @if (asset) {
        <button mat-raised-button color="primary" [disabled]="!asset" (click)="goToAssetLocation()"
            class="app-icon--goto">
            <span>Go To Asset</span>
            <mat-icon />
        </button>
        }
        @if (webhookEvent) {
        <button mat-raised-button color="primary" [disabled]="!webhookEvent"
            routerLink="/setup/integration-management/{{OrganisationUID}}/integration/{{webhookEvent.WebhookUID}}"
            [queryParams]="{ webhooktypeid: webhookEvent.WebhookType}" class="app-icon--goto">
            <span>Go To Webhook</span>
            <mat-icon />
        </button>
        }
        @if (rule) {
        <button mat-raised-button color="primary"
            routerLink="/{{accountID}}/organisation/{{OrganisationUID}}/rules/{{rule.RuleID}}"
            style="margin-left: 0.5em;" class="app-icon--goto">
            <span>Go To Rule</span>
            <mat-icon />
        </button>
        }
        @if (rule && asset) {
        <button mat-raised-button style="margin-left: 0.5em;" color="primary" (click)="ViewRule(rule)">
            <span>View Rule</span>
            <mat-icon>visibility_on</mat-icon>
        </button>
        }
        @if (deviationEvent && asset) {
        <button mat-raised-button style="margin-left: 0.5em;" color="primary" (click)="viewDistribution()">
            <span>View Model</span>
            <mat-icon>visibility_on</mat-icon>
        </button>
        }
        @if (CMMSCase && checkFeature(AccountFeatures.SAP)) {
        <button mat-raised-button style="margin-left: 0.5em;" color="primary" (click)="viewCMMS()">
            <span>view Case</span>
            <mat-icon>visibility_on</mat-icon>
        </button>
        }
        <span class="toolbar-spacer"></span>
        <button mat-raised-button (click)="goToEvents()" style="margin-bottom: 0.5em;">
            <mat-icon>notifications</mat-icon>
            <span>Events</span>
        </button>
    </div>
    @if (showChart) {
    <ejs-accordion>
        <e-accordionitems>
            <e-accordionitem [expanded]="true">
                <ng-template #header>
                    <span>Chart</span>
                </ng-template>
                <ng-template #content>
                    <div class="alignRow alignColumn">
                        @if (visibleStartDate && visibleEndDate) {
                        <span matTooltip="{{getShortDate(visibleStartDate)}} - {{getShortDate(visibleEndDate)}}"
                            class="hideoverflow">
                            {{getShortDate(visibleStartDate)}} - {{getShortDate(visibleEndDate)}}
                        </span>
                        }
                    </div>
                    <div class="graph alignColumn alignRow">
                        <ejs-chart #myChart2 id="myChart2" [primaryXAxis]='sensorXAxis' [zoomSettings]="zoomSettings"
                            [legendSettings]='legend' [tooltip]='tooltipSettings' [crosshair]='crosshair'
                            background="#FFFFFF" [border]="borderSettings" [selectionMode]='selectionMode'
                            [palettes]='palette' [height]="chartHeight" [width]="chartWidth"
                            (zoomComplete)="onZoom($event)" (scrollChanged)="onScroll($event)"
                            (chartMouseDown)="checkClick($event)" (tooltipRender)="onTooltipRender($event)">
                        </ejs-chart>
                    </div>
                    <div class="alignColumn alignRow">
                        <app-duration-selector [(duration)]="strDuration"
                            (durationChange)="selectTime($event)"></app-duration-selector>
                    </div>

                    @if (spinner) {
                    <div class="local-spinner">
                        <img src="https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/loading.gif"
                            [attr.x-contenttype]="'image/gif'" alt="Loading..." />
                    </div>
                    }
                </ng-template>
            </e-accordionitem>
        </e-accordionitems>
    </ejs-accordion>
    }
    <br>
    <div class="rule-event-details">
        @if (rule && ruleEvent) {
        <span style="font-weight: bolder;">Rule Name: </span>
        <span style="font-weight: bolder;">{{rule.RuleDescription}}</span>
        <span style="font-weight: bolder;">Timestamp:</span>
        <span style="font-weight: bolder;">{{ convertEpoch(ruleEvent.TimeStamp) }}</span>

        @if (rule.RuleMessage) {
        <span style="font-weight: bolder;">Message:</span>
        <span>{{rule.RuleMessage}}</span>
        }
        @if (rule.RuleDef){
        <span style="font-weight: bolder;">Condition:</span>
        <span style="font-weight: bolder;">{{ ruleEvent.RuleText }}</span>
        <span style="font-weight: bolder;">Values:</span>
        <span style="font-weight: bolder;" [innerHTML]="ruleValuesHtml"> </span>
        }
        @if (ruleCondition) {
        <span style="font-weight: bolder;">Operator:</span>
        <span style="font-weight: bolder;">{{ruleCondition}}</span>
        }
        <span style="font-weight: bolder;">Trigger Time:</span>
        <span style="font-weight: bolder;">{{ rule.TriggerTime }} Minutes</span>
        }
        @if (offlineEvent) {
        <span>{{ convertEpoch(offlineEvent.TimeStamp) }}</span>
        <span>Sensor Name: {{offlineEvent.SensorName}}</span>
        <span>Message: {{offlineEvent.OfflineEventText}}</span>
        }
        @if (webhookEvent){
        <span>{{ convertEpoch(webhookEvent.TimeStamp) }}</span>
        <span>Webhook: {{webhookEvent.ClientWebhookID}}</span>
        <span>Message: {{webhookEvent.WebhookEventText}}</span>
        <span>Webhook Description:</span>
        <span>{{ webhookEvent.Description }}</span>
        <span style="font-weight: bolder;">Event Type: {{ webhookEventType }}</span>
        }
        @if (deviationEvent) {
        <span style="font-weight: bold;">{{ convertEpoch(deviationEvent.Timestamp) }}</span>
        <span>Asset: <b>{{deviationEvent.AssetName}} - {{deviationEvent.AssetDescription}}</b></span>
        <span> DataPoint: <b>{{deviationEvent.DPTitle}}</b></span>
        <span> Z-Score: {{deviationEvent.ZScore}}; Tolerance: {{deviationEvent.AcceptableDeviation }}</span>
        <span> Message:</span>
        @if (deviationEvent.Sensitivity === 50) {
        <span>
            DataPoint <b>{{deviationEvent.DPTitle}}</b> had an average Z-Score of {{deviationEvent.ZScore}} which is
            above the Tolerance of {{deviationEvent.AcceptableDeviation}}.
        </span>
        }
        @else {
        <span>
            <b>{{deviationEvent.PercentageDeviated}}%</b> of the values for DataPoint
            <b>{{deviationEvent.DPTitle}}</b> were above the Tolerance of {{deviationEvent.AcceptableDeviation}}
            with an average Z-Score of {{deviationEvent.ZScore}}.
        </span>
        }
        }
    </div>
    @if (deviationEvent) {
    <br>
    <span style="display: flex; width: 100%; font-size: larger; font-weight: bold;" class="alignColumn">
        Model Details
    </span>
    @if (existingDistribution) {
    <div class="rule-event-details">
        <span>Model Type:</span>
        <span>Normal Distribution</span>
        <span>Created At: </span>
        <span style="font-weight: bold;">{{ convertEpoch(existingDistribution.CreatedAt) }}</span>
        <span>Is this an active Model?</span>
        <span> <b>{{existingDistribution.MostRecent ? " Yes. " : " No. "}}</b> This Model
            <b>{{existingDistribution.MostRecent ? " is " : " is not "}}</b> an active Model on this Asset.</span>
    </div>
    } @else {
    <div class="deleted-model alignColumn">
        <span>This model has been deleted since this event was created.</span>
    </div>
    }
    }
    <br>
    <ejs-accordion>
        <e-accordionitems>
            <e-accordionitem [expanded]="expanded">
                <ng-template #header>
                    <span>Comments ({{comments ? comments.length : 0}})</span>
                </ng-template>
                <ng-template #content>
                    @if (comments && comments.length > 0) {
                    <div>
                        <div class="comment-info-div">
                            <span>Comment Text</span>
                            <span>Timestamp</span>
                            <span>Added By</span>
                        </div>
                        @for (c of comments; track $index) {
                        <div class="comment-div">
                            <span>{{ c.CommentText }}</span>
                            @if (c.Timestamp) {<span>{{ convertEpoch(c.Timestamp) }}</span>}
                            @if (c.AddedByUserID) {<span>{{ c.AddedByUserID }}</span>}
                        </div>
                        }
                    </div>
                    }
                    <div class="add-comment-button-div">
                        <div class="add-button app-icon app-icon--add" (click)="addCommentNew()">
                            <mat-icon /><span>Add Comment</span>
                        </div>
                    </div>
                </ng-template>
            </e-accordionitem>
        </e-accordionitems>
    </ejs-accordion>

    @if (eventType !== 3) {
    <div class="acknowledge-button alignRow">
        @if (!Acknowledged && (eventType === 2 || eventType === 4)) {
        <button mat-raised-button (click)="acknowledgeEvent(true)">
            <mat-icon>done</mat-icon>
            <span>Acknowledge</span>
        </button>
        }
        @if (eventType === 1 || (eventType === 4 && Acknowledged)) {
        <button mat-raised-button (click)="acknowledgeEvent(false)" [disabled]="Acknowledged">
            <mat-icon>done</mat-icon>
            <span>Acknowledge</span>
        </button>
        }
        @if (Acknowledged && eventType === 2) {
        <button mat-raised-button (click)="reopenEvent(true)">
            <mat-icon>restore</mat-icon>
            <span>Re-Open Event</span>
        </button>
        }
    </div>
    }
    @if (Acknowledged) {
    @if (eventType === 1 && offlineEvent && offlineEvent.AcknowledgedUser)
    {
    <span class="acknowledge-button alignRow">
        Acknowledged by {{ offlineEvent.AcknowledgedUser }}
        on {{ convertEpoch(offlineEvent.AcknowledgedTimestamp)}}
    </span>
    }
    @if (eventType === 2 && ruleEvent && ruleEvent.AcknowledgedUser)
    {
    <span class="acknowledge-button alignRow">
        Acknowledged by {{ ruleEvent.AcknowledgedUser }}
        on {{ convertEpoch(ruleEvent.AcknowledgedTimestamp) }}
    </span>
    }
    @if (eventType === 4 && deviationEvent && deviationEvent.AcknowledgedUser && deviationEvent.AcknowledgedTimestamp)
    {
    <span class="acknowledge-button alignRow">
        Acknowledged by {{ deviationEvent.AcknowledgedUser }}
        on {{ convertEpoch(deviationEvent.AcknowledgedTimestamp) }}
    </span>
    }
    }
    }
    @if (deviationEvent) {
    <div class="image-div">
        <img style="max-height: 60vh; max-width: 100%;" [src]="'data:image/png;base64,' + deviationEvent.EncodedImage"
            alt="Distribution Image" />
    </div>
    }
    @if (displayTimeline && !wrongAccount && eventType === 2){
    <hr>
    <ejs-accordion id="timeline-accordion">
        <e-accordionitems>
            <e-accordionitem>
                <ng-template #header>
                    <span>Timeline</span>
                </ng-template>
                <ng-template #content>
                    <div>
                        <ng-container [ngTemplateOutlet]="timeline"></ng-container>
                    </div>
                </ng-template>
            </e-accordionitem>
        </e-accordionitems>
    </ejs-accordion>
    }
    @if (wrongAccount) {
    <div class="wrong-account-div alignColumn">
        <span style="font-size: larger; font-weight: bold;">Wrong Account</span><br>
        <span>This event exists on a different account. If you have access to the correct account, please select that
            account to view the event.</span>
    </div>
    }
</div>

<!-- <mat-menu #AddCommentMenu [overlapTrigger]="false" yPosition="above" xPosition="after">
    <div class="new-comment-div">
        <div>Write a comment</div>
        <ejs-inplaceeditor #inplace_editor2 mode="Inline" [ariaRequired]="true" name="CommentText" type="Text"
            [enablePersistence]="false" [value]='' editableOn="Click" showButtons="1"
            (actionSuccess)="AddComment($event)" style="margin-left: 1em;">
        </ejs-inplaceeditor>

        <ejs-textarea floatLabelType="Auto" cssClass="e-outline" placeholder="Outlined" rows="5"
            cols="250"></ejs-textarea>
    </div>
</mat-menu> -->

<ng-template #timeline>
    @if (Timeline && Timeline.length > 0) {
    <div class="timeline-div alignColumn">
        <ejs-timeline orientation="Vertical" alignment="Before" [template]="customTemplate" cssClass="custom-timeline">
            <e-items>
                @for (item of timelineItems; track $index) {
                <e-item [dotCss]="item.dotCss" [content]="item.content" [oppositeContent]="item.oppositeContent" />
                }
            </e-items>
            <ng-template #customTemplate let-data>
                <div class='template-container'>
                    <div class="progress-line" [ngClass]="{'last': checkNotLast(data)}">
                        <div class="indicator alignRow alignColumn">
                            @if (data.item.dotCss != '') {
                            <mat-icon style="z-index: 1001;">
                                @switch (data.item.dotCss) {
                                @case ('1') {notifications_active}
                                @case ('2') {done}
                                @case ('3') {restore}
                                @case ('4') {comment}
                                @case ('5') {content_paste}
                                @case ('6') {comment}
                                @case ('7') {assignment_turned_in}
                                @case ('8') {rules}
                                @case ('9') {rules}
                                @case ('10') {edit}
                                }
                            </mat-icon>
                            }
                        </div>
                    </div>
                    <div class="timeline-content">
                        <div class="content-container alignRow">
                            @switch (data.item.dotCss) {
                            @case ('1') {
                            @let RuleEvent = buildObject(data.item.content, data.item.dotCss);
                            <div class="timeline-element">
                                <div class="timeline-title alignRow" (click)="goToTimelineItem(data.item)">
                                    <span>Event Created</span>
                                    <span class="toolbar-spacer"></span>
                                    <span>{{convertEpochString(data.item.oppositeContent)}}</span>
                                </div>
                                <br>
                                <div class="timeline-item">
                                    <span class="timeline-item-title">Rule</span>
                                    <span class="timeline-item-title">Asset</span>
                                    <span class="timeline-item-title">Timestamp</span>
                                    <span>{{RuleEvent.RuleName}}</span>
                                    <span>{{RuleEvent.AssetName}}</span>
                                    <span>{{convertEpoch(RuleEvent.TimeStamp)}}</span>
                                </div>
                            </div>
                            }
                            @case ('2') {
                            @let RuleEvent = buildObject(data.item.content, data.item.dotCss);
                            <div class="timeline-element">
                                <div class="timeline-title alignRow" (click)="goToTimelineItem(data.item)">
                                    <span>Event Acknowledged</span>
                                    <span class="toolbar-spacer"></span>
                                    <span>{{convertEpochString(data.item.oppositeContent)}}</span>
                                </div>
                                <br>
                                <div class="timeline-item">
                                    <span class="timeline-item-title">Rule</span>
                                    <span class="timeline-item-title">Asset</span>
                                    <span class="timeline-item-title">Timestamp</span>
                                    <span>{{RuleEvent.RuleName}}</span>
                                    <span>{{RuleEvent.AssetName}}</span>
                                    <span>{{convertEpoch(RuleEvent.TimeStamp)}}</span>
                                </div>
                            </div>}
                            @case ('3') {
                            @let RuleEvent = buildObject(data.item.content, data.item.dotCss);
                            <div class="timeline-element">
                                <div class="timeline-title alignRow" (click)="goToTimelineItem(data.item)">
                                    <span>Event Re-Opened</span>
                                    <span class="toolbar-spacer"></span>
                                    <span>{{convertEpochString(data.item.oppositeContent)}}</span>
                                </div>
                                <br>
                                <div class="timeline-item">
                                    <span class="timeline-item-title">Rule</span>
                                    <span class="timeline-item-title">Asset</span>
                                    <span class="timeline-item-title">Timestamp</span>
                                    <span>{{RuleEvent.RuleName}}</span>
                                    <span>{{RuleEvent.AssetName}}</span>
                                    <span>{{convertEpoch(RuleEvent.TimeStamp)}}</span>
                                </div>
                            </div>}
                            @case ('4') {
                            @let Comment = buildObject(data.item.content, data.item.dotCss);
                            <div class="timeline-element">
                                <div class="timeline-title alignRow" (click)="goToTimelineItem(data.item)">
                                    <span>Event Comment Added</span>
                                    <span class="toolbar-spacer"></span>
                                    <span>{{convertEpochString(data.item.oppositeContent)}}</span>
                                </div>
                                <br>
                                <div class="timeline-item">
                                    <span class="timeline-item-title">Comment Text</span>
                                    <span class="timeline-item-title">Added By</span>
                                    <span class="timeline-item-title">Timestamp</span>
                                    <span>{{Comment.CommentText}}</span>
                                    <span>{{Comment.AddedByUserID}}</span>
                                    <span>{{convertEpoch(Comment.Timestamp)}}</span>
                                </div>
                            </div>}
                            @case ('5') {
                            @let Action = buildObject(data.item.content, data.item.dotCss);
                            <div class="timeline-element">
                                <div class="timeline-title alignRow" (click)="goToTimelineItem(data.item)">
                                    <span>Action Created</span>
                                    <span class="toolbar-spacer"></span>
                                    <span>{{convertEpochString(data.item.oppositeContent)}}</span>
                                </div>
                                <br>
                                <div class="timeline-item">
                                    <span class="timeline-item-title">Asset</span>
                                    <span class="timeline-item-title">Action Type</span>
                                    <span class="timeline-item-title">Details</span>
                                    <span>{{Action.AssetName}}</span>
                                    <span>{{getActionTypeFromValue(Action.ActionType)}}</span>
                                    <span>{{Action.Details}}</span>
                                </div>
                            </div>}
                            @case ('6') {
                            @let Comment = buildObject(data.item.content, data.item.dotCss);
                            <div class="timeline-element">
                                <div class="timeline-title alignRow" (click)="goToTimelineItem(data.item)">
                                    <span>Action Comment Added</span>
                                    <span class="toolbar-spacer"></span>
                                    <span>{{convertEpochString(data.item.oppositeContent)}}</span>
                                </div>
                                <br>
                                <div class="timeline-item">
                                    <span class="timeline-item-title">Comment Text</span>
                                    <span class="timeline-item-title">Added By</span>
                                    <span class="timeline-item-title">Timestamp</span>
                                    <span>{{Comment.CommentText}}</span>
                                    <span>{{Comment.AddedByUserID}}</span>
                                    <span>{{convertEpoch(Comment.Timestamp)}}</span>
                                </div>
                            </div>}
                            @case ('7') {
                            @let Action = buildObject(data.item.content, data.item.dotCss);
                            <div class="timeline-element">
                                <div class="timeline-title alignRow" (click)="goToTimelineItem(data.item)">
                                    <span>Action Completed</span>
                                    <span class="toolbar-spacer"></span>
                                    <span>{{convertEpochString(data.item.oppositeContent)}}</span>
                                </div>
                                <br>
                                <div class="timeline-item">
                                    <span class="timeline-item-title">Asset</span>
                                    <span class="timeline-item-title">Action Type</span>
                                    <span class="timeline-item-title">Details</span>
                                    <span>{{Action.AssetName}}</span>
                                    <span>{{getActionTypeFromValue(Action.ActionType)}}</span>
                                    <span>{{Action.Details}}</span>
                                </div>
                            </div>}
                            @case ('8') {
                            @let Rule = buildObject(data.item.content, data.item.dotCss);
                            <div class="timeline-element">
                                <div class="timeline-title alignRow" (click)="goToTimelineItem(data.item)">
                                    <span>Rule Disabled</span>
                                    <span class="toolbar-spacer"></span>
                                    <span>{{convertEpochString(data.item.oppositeContent)}}</span>
                                </div>
                                <br>
                                <div class="timeline-item">
                                    <span class="timeline-item-title">Rule</span>
                                    <span></span>
                                    <span></span>
                                    <span>{{Rule.RuleDescription}}</span>
                                    <span></span>
                                    <span></span>
                                </div>
                            </div>}
                            @case ('9') {
                            @let Rule = buildObject(data.item.content, data.item.dotCss);
                            <div class="timeline-element">
                                <div class="timeline-title alignRow" (click)="goToTimelineItem(data.item)">
                                    <span>Rule Re-Enabled</span>
                                    <span class="toolbar-spacer"></span>
                                    <span>{{convertEpochString(data.item.oppositeContent)}}</span>
                                </div>
                                <br>
                                <div class="timeline-item">
                                    <span class="timeline-item-title">Rule</span>
                                    <span></span>
                                    <span></span>
                                    <span>{{Rule.RuleDescription}}</span>
                                    <span></span>
                                    <span></span>
                                </div>
                            </div>}
                            @case ('10') {
                            @let RuleEdit = buildObject(data.item.content, data.item.dotCss);
                            <div class="timeline-element">
                                <div class="timeline-title alignRow" (click)="goToTimelineItem(data.item)">
                                    <span>Rule Changed</span>
                                    <span class="toolbar-spacer"></span>
                                    <span>{{convertEpochString(data.item.oppositeContent)}}</span>
                                </div>
                                <br>
                                <div class="timeline-item">
                                    <span class="timeline-item-title">Previous Conditions</span>
                                    <span class="timeline-item-title">New Conditions</span>
                                    <span class="timeline-item-title">Changed By</span>
                                    <span>{{RuleEdit.PreviousConditions}}</span>
                                    <span>{{RuleEdit.NewConditions}}</span>
                                    <span>{{RuleEdit.UserID}}</span>
                                </div>
                            </div>}
                            }
                        </div>
                    </div>
                </div>
            </ng-template>
        </ejs-timeline>
    </div>
    }
</ng-template>